// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3Arzl","right":"styles_right__1g0B5"};